import * as GQL from "src/types/graphql";

type FormSchoolRank = {
  form: { status: GQL.form_status_enum };
  offers: { status: GQL.offer_status_enum }[];
};

type FormSchool = {
  schoolId: uuid | null;
};

function canDeclineOfferByStatus(
  formSchoolRanks: FormSchoolRank[],
  allowDeclineAcceptedOffer: boolean
): boolean {
  return formSchoolRanks.every((rank) => {
    if (GQL.form_status_enum.Admissions !== rank.form.status) return false;

    const offerStatus = rank.offers?.[0]?.status;

    return (
      offerStatus === GQL.offer_status_enum.Offered ||
      (allowDeclineAcceptedOffer &&
        offerStatus === GQL.offer_status_enum.Accepted)
    );
  });
}

export function canDeclineOffers(
  formSchoolRanks: FormSchoolRank[],
  formSchools: FormSchool[],
  allowDeclineAcceptedOffer: boolean
): boolean {
  if (!formSchoolRanks || formSchoolRanks.length === 0) {
    return false;
  }

  if (formSchools.some((appSchool) => !appSchool.schoolId)) {
    return false;
  }

  const byStatus = canDeclineOfferByStatus(
    formSchoolRanks,
    allowDeclineAcceptedOffer
  );

  return byStatus;
}
